import React from "react";
import home1 from "../img/home1.png";
import { About, Description, Image, Hide } from "../styles";
//Framer Motion
import { motion } from "framer-motion";
import { titleAnim, fade, photoAnim } from "../animation";
import Wave from "./Wave";

const AboutSection = () => {
  return (
    <About>
      <Description>
        <motion.div>
          <Hide>
            <motion.h2 variants={titleAnim}>
              {" "}
              <span style={{ color: "#d64161" }}>Howdy!</span>
            </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>
              <span
                style={{
                  color: "white",
                  fontFamily: "monospace",
                }}
              >
                He
              </span>
              <span style={{ fontSize: "60px", color: "#FFA07A" }}>Y</span>{" "}
              There
              <span style={{ fontSize: "55px", color: "#333355" }}>
                !
              </span> I'm{" "}
              <span
                style={{
                  color: "#da692c",
                  fontFamily: "italic",
                }}
              >
                Ahmed
              </span>{" "}
              <br></br> Full{" "}
              <span
                style={{
                  color: "#00FFFF",
                  fontFamily: "italic",
                  fontSize: "75px",
                }}
              >
                Stack
              </span>
            </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>Developer</motion.h2>
          </Hide>
        </motion.div>
        <motion.p variants={fade}>
          <span style={{ color: "#e1e1e1", fontFamily: "cursive" }}>
            {" "}
            An enthusiastic Full-Stack Developer who likes to explore new
            technologies & seeking a challenging yet rewarding career with a
            progressive organization that provides the opportunity for
            development.
          </span>
        </motion.p>
        <a
          href="https://drive.google.com/file/d/1IsPG9KgP90PvmVyMNqaBSQEVyivAUEb9/view?usp=sharing"
          target="_blank"
        >
          <motion.button variants={fade}>My Resume</motion.button>
        </a>
      </Description>
      <Image>
        <motion.img variants={photoAnim} src={home1} alt="towsik" />
      </Image>
      <Wave />
    </About>
  );
};

//Styled Components

export default AboutSection;
